<template>
  <div class="outlineClass">
    <div class="part1" oncontextmenu = "return false" oncopy = "return false" onselectstart = "return false">
      <div class="companyPart1"></div>
      <div class="companyPart2"></div>
      <div id="outerRing" @click="outRingClick">
        <span id="softWare">软件介绍</span>
        <span id="product">产品介绍</span>
        <div id="innerRing">
        </div>
      </div>
      <div v-show="part5" class="companyPart3"></div>
      <div v-show="part6" class="companyPart4"></div>
      <div class="companyPart5" ></div>
    </div>

    <div class="part5" style="display: none" v-show="vShow">
      <span style="color:white">Copyright ©2019 创益星 版权所有 <a  style="color:white" href="https://beian.miit.gov.cn/#/Integrated/index">苏ICP备19070479号-1</a>  江苏中尚机器人科技有限公司</span>
    </div>
  </div>
</template>

<script>
    export default {
        name: "company",
      data(){
        return{
          part5:false,
          part6:true,
          vShow:false,
        }

      },
      methods:{
        outRingClick(){
          const evt = evt || window.event;
          const o = document.getElementById("outerRing");
          const innerRing = document.getElementById("innerRing");
          const x=o.getBoundingClientRect().left;
          const y=o.getBoundingClientRect().top;
          const h = o.offsetHeight;  //高度
          const w = o.offsetWidth;  //宽度
          if ((evt.screenX>x)&&(evt.screenX<(x+w/2))&&(evt.screenY>y)&&(evt.screenY>(y+h/2)))
          {
            console.log("左半边点击")
            innerRing.style.float="left";
            this.part5=true;
            this.part6=false;
          }
          if ((evt.screenX>(x+w/2))&&(evt.screenX<(x+w))&&(evt.screenY>y+h/2)&&(evt.screenY>(y+h)))
          {
            console.log("右半边点击")
            innerRing.style.float="right";
            this.part5=false;
            this.part6=true;
          }

        }
      },
    mounted(){
      window.setInterval(this.vShow=true,3000);
    }
    }
</script>

<style scoped>
  .companyPart1{
    min-height: 937px;
    background: url("../../assets/images/company/company_part1.png");
  }
  .companyPart2{
    min-height: 1084px;
    background: url("../../assets/images/company/company_part2.png");
  }
  .companyPart3{
    min-height: 924px;
    background: url("../../assets/images/company/company_part3.png");
  }
  .part5{
    background-color: black;
    text-align: center;
  }
  .companyPart4{
    min-height: 1128px;
    background: url("../../assets/images/company/company_part3_2.png");
  }
  .companyPart5{
    min-height: 858px;
    background: url("../../assets/images/company/company_part4.png");
  }
  #outerRing{
    position:relative;
    cursor:pointer;
    margin: 0 auto;
    width: 340px;
    height:50px;
    text-align:center;
    line-height:50px;
    background-color: rgb(249,249,249);
    z-index:1;
    border-radius: 80px;
  }
  #innerRing{
    width: 170px;
    height:50px;
    float: right;
    text-align:center;
    line-height:50px;
    margin: 0px 0px;
    background-color: rgb(255,241,32);
    z-index: 2;
    border-radius: 80px;
  }
  #softWare{
    position:absolute;
    line-height:50px;
    left: 60px;
    z-index: 1000;
  }
  #product{
    position:absolute;
    line-height:50px;
    right: 60px;
    z-index: 1000;
  }
  .part1{
    width: 100%;
    min-height: 1000px;
  }
</style>



// WEBPACK FOOTER //
// src/components/companyProfile/company.vue